// Pure helpers for the Email Templates page (no React, no requests).
import {isPlatformAdminRole} from '../auth/roles';

export const PAGE_SIZE = 50;

export const STATUS_COLOR = {
  published: 'success', draft: 'warning', archived: 'default',
  sent: 'success', queued: 'info', failed: 'error', bounced: 'error', delivered: 'success'
};

export const statusColor = (status) => STATUS_COLOR[status] || 'default';

// Variables the renderer fills itself (never in sample data).
export const commonVariables = (category) =>
  category === 'marketing' ? ['company_name', 'support_url', 'unsubscribe_url'] : ['company_name', 'support_url'];

// Problem with a JSON-object text field, or '' when it is fine.
export const jsonObjectError = (text) => {
  if (!text || !text.trim()) return 'Required';
  try {
    const v = JSON.parse(text);
    return v && typeof v === 'object' && !Array.isArray(v) ? '' : 'Must be a JSON object';
  } catch (e) {
    return 'Not valid JSON';
  }
};

export const prettyJson = (text) => {
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch (e) {
    return text || '{}';
  }
};

export const errorMessage = (err) => {
  const data = (err && err.response && err.response.data) || {};
  return data.message || (data.err && data.err.msg) || (err && err.message) || 'Something went wrong. Please try again.';
};

// Search body for the sent-emails list (empty filter fields left out). The
// org is not a filter: it goes in the path of the per-org search.
export const searchRequest = ({kind, status}, page) => {
  const filter = {};
  if (kind) filter.kind = kind;
  if (status) filter.status = status;
  return {filter, pageSize: PAGE_SIZE, pageOffset: page * PAGE_SIZE};
};

export const formatTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? iso : d.toLocaleString();
};

export const maxAgeLabel = (seconds) => {
  const h = Math.round(Number(seconds || 0) / 3600);
  return h >= 24 && h % 24 === 0 ? `${h / 24} d` : `${h} h`;
};

// Same rules as notification-center: templates + settings need a platform
// admin; sent emails + opt-outs also allow platform support.
export const canEditTemplates = (role) => isPlatformAdminRole(role);
export const canViewNotifications = (role) => isPlatformAdminRole(role) || role === 'platform_support';
